import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Header from "./Components/Header";
import { LanguageProvider } from "./context/LanguageContext";

const Home = lazy(() => import("./Components/Home/Home"));
const Articles = lazy(() => import("./Components/Articles/Articles"));
const Library = lazy(() => import("./Components/Library/Library"));
const Footer = lazy(() => import("./Components/Footer/Footer"));
const ContactUs = lazy(() => import("./Components/Contact/ContactUs"));
const Youtube = lazy(() => import("./Components/Youtube/Youtube"));
const Bio = lazy(() => import("./Components/BioPdf"));

// ⭐️ MUST BE INSIDE ROUTER
function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        const navbarHeight = 80;
        const offsetTop = el.offsetTop - navbarHeight;

        setTimeout(() => {
          window.scrollTo({ top: offsetTop, behavior: "smooth" });
        }, 30); // wait for components to mount
      }
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToHash />   
        <Header />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Bio" element={<Bio />} />
            {/* <Route path="/Articles" element={<Articles />} /> */}
            <Route path="/Library" element={<Library />} />
            <Route path="/ContactUs" element={<ContactUs />} />
            <Route path="/Videos" element={<Youtube />} />
          </Routes>
          <Footer />
        </Suspense>
      </Router>
    </LanguageProvider>
  );
}
export default App;
